import { useEffect, useState } from "react";
import { API_URL, authFetch } from "../../utils/auth";
import ClientProjects from "../../clients/projects/ClientProjects";
import StaffProjectsPage from "../../staff/StaffProjectsPage";

export default function ProjectsPage() {
  const role = localStorage.getItem("portal_role") || "client";
  const isSuperuser = localStorage.getItem("is_superuser") === "true";
  const isInternal = localStorage.getItem("is_internal") === "true" || isSuperuser;
  const isPartner = role === "partner";
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadProjects() {
      try {
        const response = await authFetch(`${API_URL}/client/projects/`);
        const data = await response.json();
        if (!response.ok) throw new Error(data.detail || "Unable to load projects.");
        setProjects(data.results || []);
      } catch (err) {
        setError(err.message || "Unable to load projects.");
      } finally {
        setLoading(false);
      }
    }
    if (!isInternal || isPartner) loadProjects();
  }, [isInternal, isPartner]);

  if (isInternal && !isPartner) return <StaffProjectsPage />;

  return <ClientProjects projects={projects} loading={loading} error={error} />;
}